module.exports = __webpack_public_path__ + "static/Sicilian-Olives-e64943e8ef2cbc3464f4e4e332e1af45.png";